import { render, staticRenderFns } from "./Redactor.vue?vue&type=template&id=5acb11e8&"
import script from "./Redactor.vue?vue&type=script&lang=js&"
export * from "./Redactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports